import { User } from '@mi-front/core';
import get from 'lodash/get';
import { AuthUser } from '../core/types/users';

/**
 * Returns initials from user name/surname or first two chars of email.
 */
export function getUserInitials(user: Pick<AuthUser, 'name' | 'surname' | 'email'>) {
  if (user.name && user.surname) {
    return (user.name.slice(0, 1) + user.surname.slice(0, 1)).toUpperCase();
  }

  return user.email.slice(0, 2).toUpperCase();
}

export function getUserDisplayName(user: AuthUser) {
  const providerName = get(user, 'providerData.idTokenPayload.name');

  const isShadowed = providerName === 'admin@mediainbox.io' && providerName !== user.email;
  if (isShadowed) {
    return getAppUserDisplayName(user);
  }

  return getAppUserDisplayName(user);
}

export function getAppUserDisplayName(
  user: Pick<User, 'name' | 'surname' | 'email'>,
  display: 'short' | 'long' | 'min' = 'short',
) {
  if (!user) {
    return '';
  }

  if (user.name) {
    if (display === 'short') {
      return `${user.name.slice(0, 1)}. ${user.surname}`;
    }

    if (display === 'min') {
      return `${user.name}`;
    }

    return `${user.name} ${user.surname}`;
  }

  // No name: use the email local-part (before @) as the display label.
  return user.email.split('@')[0];
}
